import styled from 'styled-components';
import { Loader as LoaderLayout } from '@playbookux/playbook-web-core';

export const BallDim = styled.div`
  position: absolute;
  width: 14px;
  height: 14px;
  background-color: #5E9FFF;
  border-radius: 50%;
  border: 2px solid #FFFF;
  pointer-events: none;
`;

export const Container = styled.div`
  position: relative;
  display: inline-block;
  max-width: 100%;
  height: auto;
  overflow: hidden;
`;

export const BaseImage = styled.img`
  ${({ isBrightness }) => isBrightness && `
    filter: brightness(50%);
  `}
  display: block;
  max-width: 100%;
  height: auto;
`;

export const Loader = styled(LoaderLayout)`
`;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1em 0;
`;
